import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetClinicPartnerInvitationsArgs } from "../schemas/invitations";

export const GET_CLINIC_PARTNER_INVITATIONS_QUERY_KEY = "getClinicPartnerInvitations";

const getClinicPartnerInvitationsQueryKey = (args: GetClinicPartnerInvitationsArgs) =>
  [GET_CLINIC_PARTNER_INVITATIONS_QUERY_KEY, args.params] as const;

export const useGetClinicPartnerInvitations = (args: GetClinicPartnerInvitationsArgs) => {
  const client = useApiClient();

  return useQuery({
    queryKey: getClinicPartnerInvitationsQueryKey(args),
    queryFn: () => client.getClinicPartnerInvitations(args),
  });
};
